/**
 * Amorce de session au démarrage.
 *
 * Aucun jeton n’étant persisté (DECISIONS §4.1), un rechargement de page repart forcément d’un
 * `POST /auth/refresh` : ce composant le déclenche **une seule fois** puis laisse le store passer
 * en `anonyme` ou `connecte`. Le garde-fou `useRef` évite le double appel du mode strict de React.
 */
import { useEffect, useRef } from 'react';

import { restaurerSession, useSessionStore } from '../api';

export function AmorcageSession() {
  const statut = useSessionStore((etat) => etat.statut);
  const lance = useRef(false);

  useEffect(() => {
    if (statut !== 'inconnu' || lance.current) return;
    lance.current = true;
    void restaurerSession()
      .then((restauree) => {
        if (!restauree) useSessionStore.getState().deconnecter();
      })
      .catch(() => {
        useSessionStore.getState().deconnecter();
      });
  }, [statut]);

  return null;
}
